import { combineReducers } from "@reduxjs/toolkit";

import mapReducer from "../pages/map/store";

const rootReducer = combineReducers({
  map: mapReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
